import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "battery_ic",
  "use": "battery_ic-usage",
  "viewBox": "0 0 15 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 22\" id=\"battery_ic\"><g fill-rule=\"nonzero\" fill=\"none\"><path d=\"M-5-2h25v25H-5z\" /><path fill=\"#333\" d=\"M0 7h15v15H0z\" /><path fill=\"#333\" d=\"M0 2h15v20H0zM5 0h5v2H5z\" /><path fill=\"#FFF\" d=\"M8.49 12.055l1.51.228L5.805 19l.705-7.055L5 11.717 9.195 5z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol